export const MAX_STREAM_BYTES = 256 * 1024;
export const MAX_EVENT_CHARS = 64 * 1024;
export const MAX_OUTPUT_CHARS = 200_000;
export const MAX_ERROR_BYTES = 8 * 1024;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function contentFromAiPayload(value: unknown): string | undefined {
  if (!isRecord(value)) throw new Error('AI 服务返回的数据结构无效。');
  if (value.error !== undefined && value.error !== null) throw new Error('AI 服务在响应中返回错误。');
  if (value.choices === undefined) return undefined;
  if (!Array.isArray(value.choices)) throw new Error('AI 服务返回的数据结构无效。');
  const choice = value.choices[0];
  if (choice === undefined) return undefined;
  if (!isRecord(choice)) throw new Error('AI 服务返回的数据结构无效。');

  for (const field of ['delta', 'message']) {
    const container = choice[field];
    if (container === undefined) continue;
    if (!isRecord(container)) throw new Error('AI 服务返回的数据结构无效。');
    const content = container.content;
    if (content === undefined) continue;
    if (typeof content !== 'string') throw new Error('AI 服务返回的数据结构无效。');
    return content;
  }
  return undefined;
}

export async function readSafeError(response: Response, apiKey: string): Promise<string> {
  if (!response.body) return '';
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let bytes = 0;
  let text = '';
  try {
    while (bytes < MAX_ERROR_BYTES) {
      const part = await reader.read();
      if (part.done) break;
      const remaining = MAX_ERROR_BYTES - bytes;
      const value = part.value.byteLength > remaining ? part.value.slice(0, remaining) : part.value;
      bytes += value.byteLength;
      text += decoder.decode(value, { stream: bytes < MAX_ERROR_BYTES });
      if (part.value.byteLength > remaining) break;
    }
  } finally {
    try {
      await reader.cancel();
    } catch {
      // 错误体可能已经自然关闭。
    }
    reader.releaseLock();
  }
  text = text.slice(0, 500);
  if (apiKey) text = text.replaceAll(apiKey, '[已隐藏密钥]');
  try {
    const parsed = JSON.parse(text) as { error?: { message?: unknown }; message?: unknown };
    const message = parsed.error?.message ?? parsed.message;
    return typeof message === 'string' ? message.slice(0, 180) : '';
  } catch {
    return text.replace(/\s+/g, ' ').slice(0, 180);
  }
}
